import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Table, TableContainer, Paper } from "@material-ui/core";

// Единый стиль таблиц админки. Стилизует шапку и ячейки через вложенные
// селекторы, поэтому вкладкам достаточно обернуть таблицу в <AdminTable> —
// переписывать каждую <TableCell> не нужно.
const useStyles = makeStyles((theme) => ({
  container: {
    boxShadow: "none",
    border: "1px solid #E1E6F1",
  },
  table: {
    minWidth: 650,
    "& thead th": {
      backgroundColor: "#F3F5F7",
      fontWeight: 600,
      color: "#1A1E24",
      fontSize: "14px",
      padding: theme.spacing(1.5, 2),
      borderBottom: "1px solid #E1E6F1",
    },
    "& tbody td": {
      padding: theme.spacing(1.5, 2),
      borderBottom: "1px solid #E1E6F1",
      fontSize: "14px",
    },
  },
}));

const AdminTable = ({ children, className }) => {
  const classes = useStyles();
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table className={`${classes.table} ${className || ""}`}>
        {children}
      </Table>
    </TableContainer>
  );
};

export default AdminTable;
